import React from 'react';
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import styled from 'styled-components';
import boatImage from '../assets/boatImage.jpg';
import stairs from '../assets/stairs.jpg';
import firebase from '../firebase'
import moment from 'moment';

const Styles = styled.div`
  .jumbo {
    background: url(${stairs}) no-repeat fixed bottom;
    background-size: cover;
    color: #efefef;
    height: 200px;
    position: relative;
    z-index: -2;
  }
  .overlay {
    background-color: #000;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
  }
`;

// var today = new Date(),
// date = (today.getMonth() + 1) + '-' + today.getDate() + '-' + today.getFullYear();

const date = new Date()
const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: '2-digit' }) 
const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
const m = (`${month} ${date.getDate()}, ${year }`)


export const Jumbotron = () => (
  <Styles>
    <Jumbo fluid className="jumbo">
      <div className="overlay"></div>
      <Container>
        <h1>Featured Podcasts</h1>
        <div class="intro"> {m} </div>
      </Container>
    </Jumbo>
  </Styles>
)